import React, { FC } from 'react';

interface IComponentProps {
  discount?: number;
  min?: boolean;
}

export const GoodDiscount: FC<IComponentProps> = ({ discount = 0, min = false }) => {
  return discount <= 0 ? null : <span className="good-discount">{min ? `-${discount}%` : `Скидка -${discount}%`}</span>;
};
